
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 2.5v18m-21 0v-18m22 20a1 1 0 01-1 1h-21a1 1 0 01-1-1V21a.5.5 0 01.5-.5h22a.5.5 0 01.354.146.5.5 0 01.146.354v1.5zM20 8.5H4a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h16a.5.5 0 00.5-.5V9a.5.5 0 00-.5-.5zm-13.5 3h11m-2-5a1 1 0 100-2 1 1 0 000 2zm4 0a1 1 0 100-2 1 1 0 000 2zm-7.5-2H4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h8a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5zM23.5 2a.5.5 0 01-.5.5H1A.5.5 0 01.5 2v-.5a1 1 0 011-1h21a1 1 0 011 1V2z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    